import { AssetShape } from '@blockworks/platform/api/research/assets';
import { Tag } from '@blockworks/platform/api/strapi';
import { FlexBox, List } from '@blockworks/ui/components';

import { assetQueries } from '@/api/assets/queries';
import AssetWidget from '@/components/asset-widget/asset-widget';

const RelatedAssets = ({ tags }: { tags: Tag[] | null | undefined }) => {
    const assetTags = tags?.filter(tag => tag.isAsset);
    const assetSlugs = assetTags?.map(asset => asset.slug) ?? [];
    const assetNames = assetTags?.map(asset => asset.name) ?? [];

    const assetsQuery = assetQueries.getAssets.use({
        variables: { assets: assetSlugs ?? [], limit: 50 },
        select: assetQueries.getAssets.select.assetsAndTotal,
        enabled: assetSlugs.length > 0,
        placeholderData: { data: [], _meta: { total: 0, success: true } },
    });

    if (!assetsQuery.data?.assets?.length) {
        return null;
    }

    const assetsLookup: { [code: string]: AssetShape } = {};

    for (const asset of assetsQuery.data.assets) {
        const existingAsset = assetsLookup[asset.code];

        if (
            // IF there is NOT a duplicate asset, add it to the lookup
            !existingAsset ||
            // OTHERWISE, pick the one with the same name
            assetNames.includes(asset.title) ||
            // OR, pick the one with the higher market cap rank
            existingAsset.marketcap.rank > asset.marketcap?.rank
        ) {
            assetsLookup[asset.code] = asset;
        }
    }

    const relatedAssets = Object.values(assetsLookup);

    return (
        <div className="max-h-400px print:hidden">
            <List variant="compact" divided h={assetsQuery.data.totalCount > 5 ? 400 : undefined}>
                {relatedAssets.map((asset, idx) => (
                    <List.Row key={asset.id}>
                        <List.Col size="fill" grow flush="bot">
                            <FlexBox py={4} w="full" col alignItems="stretch">
                                <AssetWidget asset={asset} initiallyExpanded={idx === 0} />
                            </FlexBox>
                        </List.Col>
                    </List.Row>
                ))}
            </List>
        </div>
    );
};

export default RelatedAssets;
